<template>
  <div class="ima-settings">
    <h1 class="title">Einstellungen</h1>

    <div class="columns" v-if="!isForcedPasswordChange">
      <div class="column">
        <b-field label="E-Mail Adresse">
          <b-input type="email" v-model="email" :required="true" expanded :disabled="user.isChangingEmail"></b-input>
        </b-field>
        <button type="button" class="button is-danger" :class="{'is-loading' :  user.isChangingEmail}" @click="onChangeEmail " :disabled="!emailIsValid || user.isChangingEmail">E-Mail ändern</button>
      </div>
    </div>

    <div class="columns">

      <div class="column">

         <p v-if="isForcedPasswordChange" class="ima-settings__password-change">Sie müssen Ihr Passwort ändern</p>

        <b-field label="Passwort">
          <b-input type="password" v-model="password" :required="true " expanded minlength="3" :disabled="user.isChangingPassword"></b-input>
        </b-field>
        <b-field label="Passwort (Wdh.)" :message="passWordMessages" :type="passwordStatus">
          <b-input type="password" v-model="password2" :required="true " expanded minlength="3" :disabled="user.isChangingPassword"></b-input>
        </b-field>
        <button type="button" class="button is-danger" :class="{'is-loading' :  user.isChangingPassword}" :disabled="!passwordIsValid || user.isChangingPassword" @click="onChangePassword">Passwort ändern</button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { changeEmail, changePassword } from '@/store/modules/user'
import routes from '@/mixins/routes'
import router from '@/router'

export default {
  name: 'ima-settings',
  mixins: [routes],
  data () {
    return {
      email: null,
      password: null,
      password2: null
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isForcedPasswordChange']),
    emailIsValid () {
      return this.email !== this.user.data.email
    },
    passwordIsValid () {
      return this.password && this.password2 && !this.passWordMessages.length
    },
    passWordMessages () {
      const messages = []
      if (this.password && this.password2 && this.password !== this.password2) {
        messages.push('Die Passwörter stimmen nicht überein')
      }
      if (this.password && !this.password2) {
        messages.push('Geben Sie zur Überprüfung das Passwort erneut ein')
      }
      return messages
    },
    passwordStatus () {
      if (this.password && this.password2 && this.password !== this.password2) {
        return 'is-danger'
      }
      if (this.password && !this.password2) {
        return 'is-warning'
      }
      if (this.passwordIsValid) {
        return 'is-success'
      }
    }
  },
  methods: {
    ...mapActions([changeEmail, changePassword]),
    onChangeEmail () {
      this.changeEmail(this.email).then(() => {
        router.push({ name: this.routes.DASHBOARD })
      })
    },
    onChangePassword () {
      this.changePassword(this.password).then(() => {
        router.push({ name: this.routes.DASHBOARD })
      })
    }
  },
  created () {
    this.email = this.user.data.email
  }
}
</script>

<style lang="scss">
@import '../scss/settings';
.ima-settings {
  max-width: 30rem;

  &__password-change {
    color: $danger;
    margin: 1rem 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Settings.vue